import React from 'react';
import { Tabs, Tab } from '@mui/material';

interface TabsProps {
  labels: string[] | number[];
  selectedTab: string | number;
  onChange: (event: React.SyntheticEvent, newValue: string | number) => void;
  className?: string;
}

const CustomTabs: React.FC<TabsProps> = ({ labels, selectedTab, onChange }) => {
  return (
    <Tabs value={selectedTab} onChange={onChange} className="tab_wrap">
      {labels.map((label, index) => (
        <Tab
          key={index}
          label={label}
          className={`tab-title ${selectedTab === label ? 'selected-tab' : 'unselected-tab'}`}
        />
      ))}
    </Tabs>
  );
};

export default CustomTabs;
